import { defineComponent as o, openBlock as n, createElementBlock as l, Fragment as t, renderSlot as e } from "vue";
import { _ as a } from "../../../_plugin-vue_export-helper-dad06003.js";
const r = o({
  name: "RResponsiveElement",
  data: () => ({
    cssClassDesktop: "hobi-show-on-large",
    cssClassMobile: "hobi-hide-on-large"
  })
});
function p(s, i, c, m, d, f) {
  return n(), l(t, null, [
    e(s.$slots, "desktop", { classDesktop: s.cssClassDesktop }),
    e(s.$slots, "mobile", { classMobile: s.cssClassMobile })
  ], 64);
}
const $ = /* @__PURE__ */ a(r, [["render", p]]);
export {
  $ as default
};
